import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import AccountService from '../../Services/http/AccountService';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setIsActiveSpinner } from '../../Redux/GeneralSlice';

export default function FirstMonthSummaryDialog(props) {
    const { open, setOpen, accountId, setAccountId } = props;
    const [isNotRelevantSend, setIsNotRelevantSend] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [data, setData] = useState({});
    const dispatch = useDispatch();

    const handleClose = () => {
        setAccountId(null);
        setIsSuccess(false);
        setIsNotRelevantSend(false);
        setOpen(false);
    };

    useEffect(() => {
        if (accountId) {
            dispatch(setIsActiveSpinner(true));
            AccountService.getSummaryReimbursements(accountId).then(res => {
                dispatch(setIsActiveSpinner(false));
                if (res) {
                    if (res['message'] == 'not_relevant') {
                        setIsNotRelevantSend(true);
                    } else if (res['message'] === 'success') {
                        setIsSuccess(true);
                        setData(res);
                        console.log(data);
                    } else if (res['message'] === 'error') {
                        alert('An error occurred');
                    } else {
                        console.log('Unknown!');
                    }

                } else {
                    alert('An error occurred');
                }
            });
        }
    }, [accountId]);

    const sendSummaryReimbursementsEmail = () => {
        dispatch(setIsActiveSpinner(true));
        AccountService.sendSummaryReimbursementsEmail(accountId).then(res => {
            console.log(res);
            dispatch(setIsActiveSpinner(false));
            if (res && res['message'] === 'success') {
                handleClose();
                alert('success');
            } else {
                alert('An error occurred');
            }
        });
    };

    const formatFloat = (num) => {
        return num.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    };

    const getMonthForSending = () => {
        const amountTotalBy12Months = data['other']['12']['amount_total'];
        const otherAmountTotalBy18Months = data['other']['18']['amount_total'];
        if (amountTotalBy12Months <= otherAmountTotalBy18Months)
            return '12';
        else
            return '18';
    };

    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"First Month Summary!"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {isNotRelevantSend && <span>
                            30 days have not yet passed since the first case the account received, so it is not possible to view the information or send an email to the account
                        </span>}
                        {isSuccess && <span>
                            <span className='bold'>Better Refund's cases</span><br></br>
                            <span>In the last month: ${formatFloat(data['our_amount_total'])}</span><br></br><br></br>
                            <span className='bold'>Other's cases</span><br></br>
                            <span className={getMonthForSending() === '18' ? 'yellow-bgcolor' : ''}>According to 18 months -
                                ${formatFloat(data['other']['18']['amount_total_per_month'])} a month on average (${formatFloat(data['other']['18']['amount_total'])} total in the last 18 months)</span><br></br>
                            <span className={getMonthForSending() === '12' ? 'yellow-bgcolor' : ''}>According to 12 months - ${formatFloat(data['other']['12']
                            ['amount_total_per_month'])} a month on average
                                (${formatFloat(data['other']['12']['amount_total'])} total in the last 12 months)</span>
                        </span>}
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ justifyContent: "center" }}>
                    <Button disabled={!isSuccess} onClick={sendSummaryReimbursementsEmail}>Send</Button>
                    {/* <Button onClick={handleClose}>Close</Button> */}
                </DialogActions>
            </Dialog>
        </div>
    );
}